<style lang="scss"
       module>
@import '../brand/brandColors';
@import '../brand/structure.variables';

.wrapper {
  composes: wrapper from 'sass-loader!../brand/structure.module.scss';
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
}

.innerWrap {
  composes: innerWrap from 'sass-loader!../brand/structure.module.scss';
}

.videoWrap {
  position: relative;
  height: 0;
  overflow: hidden;
  margin: 3.5rem 0;
  width: 100%;
  padding-bottom: 56.25%;
}

.videoFrame {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /*min-width: 37.2rem;*/
}

.standard {
  composes: standard from 'sass-loader!../brand/typography.module.scss';
  text-align: center;
}

.midhead {
  text-align: center;
}

.solutions {
  position: relative;
  composes: innerWrap;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: flex-start;
}

@media screen and (min-width: $mobile) {
  .videoWrap {
    margin: 3.5rem $column-inset;
    width: calc(100% - 2 * #{$column-inset});
  }
}
</style>
<template>
  <div :class="$style.wrapper">
    <div :class="$style.innerWrap">
      <p :class="$style.standard">Some of our best solutions have been developed from a problem that seemed impossible to solve.<br>With our extensive product experience, in-house testing lab, and commitment to teamwork and partnerships, we have found creative, cost-efficient solutions to our customers’ most difficult problems.
      </p>
    </div>
    <CTA/>
    <div :class="$style.innerWrap">
      <div :class="$style.videoWrap">
        <iframe
          :class="$style.videoFrame"
          src="https://player.vimeo.com/video/270375979"
          frameborder="0"
          webkitallowfullscreen
          mozallowfullscreen
          allowfullscreen/>
      </div>
    </div>
    <h2 :class="$style.midhead">How go2 partners keeps your lines moving</h2>
    <div :class="$style.solutions">
      <Solution
        :id="1"
        :open-id="openId"
        head="national footprint"
        subhead="Keeping you stocked across the U.S."
        content="With over 40 locations just in the United States, we are always searching out new strategically placed locations to assist with delivery and production times. We understand that, when it comes to shipping labels, getting supplies is critical."
        stat="stat"
        @openModule="moveModule"/>
      <Solution
        :id="2"
        :open-id="openId"
        :is-blue="false"
        head="best-in-class qc"
        subhead="Labeling defects are never your problem"
        content="We have 7 specific areas that we quality test our labels for, including tack, adhesion, release, print quality, barcode verification, die cut depth, and dispensing. This allows us to fix any problem before labels ever reach the fulfillment or distribution center."
        stat="stat"
        @openModule="moveModule"/>
      <Solution
        :id="3"
        :open-id="openId"
        :is-blue="false"
        head="new product development"
        subhead="Bring us your challenges"
        content="We have created, tested, and executed dozens of new products for world-class companies. From challenging environments to specific security needs, we support the unique aspects of your business that call for strategy and innovation because our team applies creative thinking to everything we do."
        stat="stat"
        @openModule="moveModule"/>
      <Solution
        :id="4"
        :open-id="openId"
        head="technical expertise"
        subhead="We know your business"
        content="We don’t just get by with the basics. We’ll travel to your facilities to learn about your unique challenges so we can offer quick solutions to any issue you encounter. And, with thousands of hours in North American DCs and FCs, we are already experts in workflow efficiency, printers, and print and apply equipment."
        stat="stat"
        @openModule="moveModule"/>
      <Solution
        :id="5"
        :open-id="openId"
        head="responsive service"
        subhead="It’s all about our customers"
        content="We want your business to succeed, whatever it takes. That includes jumping in a car—or on a plane—at a moment’s notice to help you when you are in a jam. Keeping your distribution center running smoothly is priority and we are routinely on site within 24 hours."
        stat="stat"
        @openModule="moveModule"/>
      <Solution
        :id="6"
        :open-id="openId"
        :is-blue="false"
        head="cost-efficient critical supplies"
        subhead="The benefits of buying power"
        content="GO2 Partners has over 3,000 network partners across the globe, which gives us the ability to purchase high-quality materials at extremely competitive rates. That also means we never run out of your critical distribution supplies, so your lines will never shut down due to lack of product."
        stat="stat"
        @openModule="moveModule"/>
      <SolutionOpen
        v-if="modalOpen"
        :modal-top="modalTop"
        :modal-left="modalLeft"
        :head="headline"
        :subhead="subhead"
        :content="content"
        :stat="stat"
        :is-blue="isBlue"
        @close="closeModals"/>
    </div>
    <CTA :is-black="true"/>
  </div>
</template>

<script>
/* Vue Components */
import CTA from '../components/cta/CTA.vue';
import SolutionOpen from '../components/solution/Solution.Open.vue';
import Solution from '../components/solution/Solution.vue';
/* Meteor packages */
/* NPM packages */
/* Methods */
/* Everything else */

export default {
  name: 'AppContent',
  components: {
    CTA,
    Solution,
    SolutionOpen,
  },
  data() {
    return {
      modalOpen: false,
      modalTop: '',
      modalLeft: '',
      headline: '',
      subhead: '',
      content: '',
      stat: '',
      isBlue: true,
      openId: 0,
    };
  },
  methods: {
    moveModule(
      top,
      left,
      head,
      subhead,
      content,
      stat,
      isBlue,
      id,
      isMobileView,
    ) {
      this.modalTop = top;
      this.modalLeft = left;
      this.headline = head;
      this.subhead = subhead;
      this.content = content;
      this.stat = stat;
      this.isBlue = isBlue;
      this.openId = id;
      if (!isMobileView) {
        this.modalOpen = true;
      }
    },
    closeModals() {
      this.modalOpen = false;
      this.openId = 0;
    },
  },
};
</script>
